<section class="main_section">
    <div class="top-content">
        <div class="close_btn" (click)="close()">
            <mat-icon class="d-flex justify-content-end">close</mat-icon>
        </div>
    </div>
    <div class="main-content">
        <div class="website-type">
        <div class="website-type-card cursor-pointer" (click)="websiteType = 'STATIC'">
            <div class="image-container mb-1" [ngClass]="{'status': websiteType === 'STATIC'}">
                <img class="select-business-type w-100" src="https://prod-simpo.s3.ap-south-1.amazonaws.com/prod-images/708340c1744702238560freepik--Device--inject-74%20%282%29.png" alt="information">
            </div>
            <div class="type-name">Information</div>
        </div>
        <div class="website-type-card cursor-pointer" (click)="websiteType = 'E_COMMERCE'">
            <div class="image-container mb-1" [ngClass]="{'status': websiteType === 'E_COMMERCE'}">
                  <img class="select-business-type w-100" src="https://prod-simpo.s3.ap-south-1.amazonaws.com/prod-images/488590c1744702029435Add%20to%20Cart-cuate%202.png" alt="online_store">                  
            </div>
            <div class="type-name">Online Store</div>
        </div>

        </div>
        <div class="bottom_layer">

            
            <div class="location_change">
                <div class="regenerate_location">
                    <div class="label_heading">Industry Type</div>
                    <mat-form-field class="location-field w-100" appearance="outline" *ngIf="websiteType === 'STATIC'"
                        [ngClass]="{'error-border': !isIndustryTypeSelected && (isBusinessNameClicked || isSuggestedNamesClicked)}">

                        <input type="text" placeholder="Enter Industry type" matInput [formControl]="industrySelectControl"
                            [matAutocomplete]="auto1" [(ngModel)]="bType" />
                        <mat-autocomplete #auto1="matAutocomplete">
                            <mat-option *ngFor="let option of filteredIndustries | async; index as i" [value]="option.name"
                                (click)="selectBusinessType(option)" (keyup.enter)="selectBusinessType(option)">
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field class="location-field w-100" appearance="outline" *ngIf="websiteType === 'E_COMMERCE'">

                    <input type="text" placeholder="Enter Industry type"
                        matInput [(ngModel)]="bType"
                        [formControl]="ecommerceIndustrySelectControl"
                        [matAutocomplete]="auto1"
                    />
                    <mat-autocomplete #auto1="matAutocomplete">
                        <mat-option *ngFor="let option of filteredEcommerceIndustries | async; index as i" [value]="option.name"
                            (click)="selectBusinessType(option)"
                            (keyup.enter)="selectBusinessType(option)"
                            id="searchValue"
                        >
                            {{ option.name | titlecase }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                    <!-- <div *ngIf="!isIndustryTypeSelected && (isBusinessNameClicked || isSuggestedNamesClicked)" class="error-text">
                        Please select the industry type
                    </div> -->
                </div>
            </div>
            
            <div class="location_change">
                <div class="regenerate_location">
                    <div class="label_heading">Location</div>
                    <mat-form-field class="location-field w-100" appearance="outline">
                        <input type="text" placeholder="Search for location" matInput [formControl]="searchBox" [matAutocomplete]="auto2"
                        [(ngModel)]="searchLocation" (ngModelChange)="search()"/>
                        <mat-autocomplete #auto2="matAutocomplete">
                            <mat-option *ngFor="
                                let option of searchResults | async;
                                index as i
                            " [value]="option.displayName" (click)="selectedLocations(option)">
                                {{ option.displayName | titlecase }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>


            <div class="bottom_section" style="margin-top: 10px; text-align: left; display: flex; flex-wrap: wrap;">
                <div class="taking_input">
                    <div class="label_heading">Business Name </div>
                    <mat-form-field class="location-field w-100" appearance="outline">
                        <input type="text" placeholder="Enter business name" matInput [formControl]="businessNameControl"
                            [(ngModel)]="bName" (focus)="onBusinessNameFocus()" />
                    </mat-form-field>
                </div>
                <!-- <div class="suggest_businessType">
                    Not Sure?
                    <span style="color: #0496ff; cursor: pointer; font-weight: 500;"
                        [ngClass]="{'disabled-link': !isIndustryTypeSelected}"
                        (click)="isIndustryTypeSelected ? seeSuggestedNames() : null">
                        See some suggestions
                        <img src="./../../../../../assets/images/common/suggestions_bulb.svg" alt="bulb" />
                    </span>
                </div> -->
            </div>

        </div>
        <!-- <div class="bottom_section" *ngIf="suggestedNamesScreen">
            <div class="some_suggesions">Here are some suggestions</div>
            <div class="suggestions"
                style="border-radius: 10px; background-color: white; margin-top: 10px;text-align: left;display: flex;flex-wrap: wrap;">
                <ng-container *ngFor="let item of suggestNames">
                    <button class="chips" (click)="clickedSuggestions(item)">{{ item.bName | titlecase}}</button>
                </ng-container>
            </div>
            <div class="enter_own_section">
                <div class="enter_own" (click)="enterOwnBName()">
                    <mat-icon>keyboard_backspace</mat-icon>&nbsp;Enter my own
                </div>
                <div class="see_more" (click)="seeMore()">
                    <mat-icon>refresh</mat-icon> &nbsp;See more
                </div>
            </div>
        </div> -->

        <div class="footer_layer">
            <button (click)="bName && bType && searchLocation ? generateWebsite() : showSnackbar()">
                <span *ngIf="createBusinessLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
                <span *ngIf="!createBusinessLoader">Generate Website</span>
            </button>
        </div>
    </div>
</section>
